<template>
  <div class="table-responsive">
    <table class="table mb-0">
      <thead class="table-light">
        <tr>
          <th>A/A</th>
          <th>Όνομα</th>
          <th>IP</th>
          <th>Port</th>
          <th>Ενεργό</th>
          <th>Σύνδεδεμένο</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(device, index) in devices" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ device.device_name }}</td>
          <td>{{ device.device_ip }}</td>
          <td>{{ device.device_port }}</td>
          <td v-if="device.active">
            <i class="fas fa-check-circle" style="color:green"></i>
          </td>
          <td v-else>
            <i class="fas fa-power-off" style="color:red "></i>
          </td>

          <td v-if="device.is_connected">
            <i class="fas fa-check-circle" style="color:green"></i>
          </td>
          <td v-else>
            <i class="fas fa-power-off" style="color:red "></i>
          </td>
          <td>
            <button
              type="button"
              class="btn btn-warning btn"
              @click="$bvModal.show(device.device_name)"
              style="margin-right:20px"
            >
              <i class="mdi mdi-pencil"></i>
            </button>
            <button
              type="button"
              class="btn btn-danger btn"
              @click.prevent="deleteDeviceConfirm(device)"
            >
              <i class="mdi mdi-trash-can"></i>
            </button>
          </td>

          <td>
            <!-- Start Modal -->
            <UpdateDeviceModal
              :deviceObject="device"
              @deviceUpdated="refreshDevices"
            ></UpdateDeviceModal>

            <!-- End of modal -->
          </td>
        </tr>
      </tbody>
    </table>
    <CreateDevice @deviceCreated="refreshDevices"></CreateDevice>
  </div>
</template>

<script>
import session from "../../../../../api/session";
import UpdateDeviceModal from "./UpdateDeviceModal.vue";
import CreateDevice from "./CreateDevice.vue";
import Swal from "sweetalert2";
import { eventCreate } from "../../../../../eventspy";
export default {
  name: "FirstTab",
  components: {
    UpdateDeviceModal,
    CreateDevice,
  },
  props: {
    devices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // devices: [],
    };
  },

  methods: {
    refreshDevices() {
      this.$emit("fetchDevices");
      this.$forceUpdate();
    },
    deleteDeviceConfirm(device) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          const isDeleted = this.deleteDevice(device);
          if (isDeleted) {
            Swal.fire(
              "Διαγράφηκε!",
              "Η συσκευή σας έχει διαγραφεί.",
              "success"
            );
          } else {
            Swal.fire(
              "Ουπς!",
              "Προέκυψε ενα πρόβλημα και η συσκευή δεν διαγραφηκε",
              "error"
            );
          }
        }
      });
    },
    async deleteDevice(device) {
      await session
        .delete(`api/device/${device.id}/delete/`)
        .then(() => {
          eventCreate(
            `Διεγραψε την συσκευή 
            device_name :${device.device_name}
            device_ip: ${device.device_ip}, 
            device_port: ${device.device_port},
            active: ${device.active} `,
            3
          );
          this.refreshDevices();

          return true;
        })
        .catch((e) => {
          console.log(e.response.data);
          return false;
        });
    },
  },
};
</script>
